import React from 'react';
import { Card, CardBody, Table, Button, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { SettingAction } from 'redux/actions';

const AppForceUpdate = (props) => {

    let [values, setValues] = React.useState({});
    let [actionValues, setActionValues] = React.useState({});
    const items = [
        {
            label: 'Android app version smaller than',
            key: 'android',
            placeholder: 'app version'
        },
        {
            label: 'IOS app version smaller than',
            key: 'ios',
            placeholder: 'app version'
        }
    ];
    React.useEffect(() => {
        props.getAppVersion({});
    }, []);
    const handleChange = (event) => {
        setValues({
            ...values, [event.target.name]: event.target.value
        })
    };

    const handleActionChange = (event) => {
        setActionValues({
            ...actionValues, [event.target.name]: event.target.value
        })
    };
    React.useEffect(() => {

        let responseVersions = [];
        let responseAction = [];
        props.versionSetting && (props.versionSetting).forEach((item) => {
            responseVersions[`${item.device_type}`] = item.app_version;
            responseAction[`${item.device_type}`] = item.notify_for_update;
        });
        setValues(responseVersions);
        setActionValues(responseAction)
    }, [props.versionSetting]);


    
    const updateActionsItems = [
        {
            key: 1,
            label: 'Show alert only'
        },
        {
            key: 2,
            label: 'Force Update'
        }
    ]
    const generateAppSettingRow = () => {

        
        return items.map((item, index) => {
            const defVal = (actionValues && actionValues[`${item.key}`])?parseInt(actionValues[`${item.key}`]):0;
            return (
                <tr key={item.key}>
                    <td>{item.label}</td>
                    <td>
                        <Input
                            type="text"
                            placeholder={item.placeholder}
                            name={item.key}
                            id={item.key}
                            onChange={handleChange}
                            autoComplete={'off'}
                            value={(values && values[`${item.key}`]) ? values[`${item.key}`] : ''}
                            style={{ width: 300 }}
                        />
                    </td>
                    <td>
                        <Input
                            onChange={handleActionChange}
                            className="mb-2"
                            name={item.key}
                            id={item.key}
                            type="select"
                            style={{ width: 200 }}>
                            <option value={0}>No Action</option>
                            {updateActionsItems.map((itemVal) => (<option selected={(defVal===itemVal.key)?true:false} key={itemVal.key} value={itemVal.key}>{itemVal.label}</option>))}
                        </Input>
                    </td>
                    <td>
                        <Button color="primary" style={{ display: 'block', marginBottom: '10px' }} className="border-0" onClick={()=>handleSubmit(item.key)}>{'Save'}</Button>
                    </td>
                </tr>
            );
        })
    }

    const handleSubmit = (device_type)=>{

        const payloadValues = {...values};
        const payloadActionValues = {...actionValues};

        console.log('payloadValues', payloadActionValues)
        const payload = {app_version:payloadValues[device_type],device_type:device_type,notify_for_update:payloadActionValues[device_type]}
        props.saveAppVersion(payload);

    }

    return (
        <Card className="mb-3">
            <CardBody>
                <Table responsive>
                    <thead>
                        <tr>
                            <th colspan="4">App Force Update When</th>
                        </tr>
                    </thead>
                    <tbody>
                        {generateAppSettingRow()}
                    </tbody>
                </Table>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = (state) => ({
    versionSettingSaved: (state.setting && state.setting.versionSettingSaved) ? state.setting.versionSettingSaved : null,
    versionSetting: (state.setting && state.setting.versionSetting && state.setting.versionSetting.data) ? state.setting.versionSetting.data : null,
});
const mapDispatchToProps = (dispatch) => ({
    saveAppVersion: (payload) => dispatch(SettingAction.saveAppVersion(payload)),
    getAppVersion: (payload) => dispatch(SettingAction.getAppVersion(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AppForceUpdate);
